import React, { useEffect, useState } from "react";
import productIcon from '../../../../assets/icons/products.svg';
import { useNavigate, useParams } from "react-router-dom";
import ImagePicker from "../../../../components/LoginFormComponents/ImagePicker";
import ProfileIntiationLablesContainer from "../../../../components/DashboardComponents/ProfileIntiationLablesContainer";
import FormSeperator from "../../../../components/LoginFormComponents/FormSeperator";
import { Button } from 'primereact/button';
import axios from 'axios';
import GetRequest from '../../../../service/GetRequest';
import InputSelectionDropdown from "../../../../components/Widgets/Inputs/InputSelectionDropdown";
import InputFeildTextArea from "../../../../components/Widgets/Inputs/InputFeildTextArea";
import InputFieldText from "../../../../components/Widgets/Inputs/InputFieldText";
import AddProductForm from "../../../../components/Widgets/Forms/AddProductForm";
import CookieHandler from '../../../LandingPage/Authentication/CookieHandler'

const AddProductsPage = ({ setActivePath }) => {

    const token = CookieHandler.getCookie('token');

    const navigate = useNavigate();
    const { branchId } = useParams();
    const [categories, setCategories] = useState([]);
    const [selectedCategoryId, setSelectedCategoryId] = useState();
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [image, setImage] = useState(null);
    const [size, setSize] = useState("Small");
    const [color, setColor] = useState("Black");
    const [material, setMaterial] = useState("");
    const [quantity, setQuantity] = useState(0);
    const [sellingPrice, setSellingPrice] = useState(0);
    const [purchasePrice, setPurchasePrice] = useState(0);
    const [currency, setCurrency] = useState("GBP");
    const [isTaxable, setIsTaxable] = useState(false);
    const [taxRate, setTaxRate] = useState(0);
    const [sellerDescription, setSellerDescription] = useState("");
    const [warrantyDetails, setWarrantyDetails] = useState("");

    const sizeOptions = [
        { value: 'Small', label: 'Small' },
        { value: 'Medium', label: 'Medium' },
        { value: 'Large', label: 'Large' },
    ];

    const currencyOptions = [
        { value: 'GBP', label: 'British Pound (GBP)' },
        { value: 'INR', label: 'Indian Rupee (INR)' },
        { value: 'USD', label: 'US Dollar (USD)' },
        { value: 'EUR', label: 'Euro (EUR)' },
        { value: 'JPY', label: 'Japanese Yen (JPY)' },
        { value: 'CAD', label: 'Canadian Dollar (CAD)' },
        { value: 'AUD', label: 'Australian Dollar (AUD)' },
        { value: 'CNY', label: 'Chinese Yuan (CNY)' },
        { value: 'CHF', label: 'Swiss Franc (CHF)' },
        { value: 'BRL', label: 'Brazilian Real (BRL)' },
    ];

    useEffect(() => {
        setActivePath("Dashboard");
        GetRequest(`v1/inventory-service/view/branches/${branchId}/categories`,true)
            .then(response => {
                if (response) {
                    setCategories(response);
                    setSelectedCategoryId(response[0].categoryId)
                } else {
                    console.log("No categories found for this branch");
                }
            })
            .catch(error => {
                console.error("Error fetching categories:", error);
            });
    }, [setActivePath, branchId]);

    const handleNameChange = (e) => setName(e.target.value);
    const handleCategoryChange = (e) => {
        console.log(e.target.value);
      
        // Set the selected category ID using the value from the event target
        setSelectedCategoryId(e.target.value);
      };
    const handleDescriptionChange = (e) => setDescription(e.target.value);
    const handleImageChange = (file) => setImage(file);
    const handleSizeChange = (e) => setSize(e.target.value);
    const handleCurrencyChange = (e) => setCurrency(e.target.value);
    const handleColorChange = (e) => setColor(e.target.value);
    const handleMaterialChange = (e) => setMaterial(e.target.value);
    const handleQuantityChange = (e) => setQuantity(Number(e.target.value));
    const handleSellingPriceChange = (e) => setSellingPrice(Number(e.target.value));
    const handlePurchasePriceChange = (e) => setPurchasePrice(Number(e.target.value));
    const handleIsTaxableChange = (e) => setIsTaxable(e.target.value === "true");
    const handleTaxRateChange = (e) => setTaxRate(Number(e.target.value));
    const handleSellerDescriptionChange = (e) => setSellerDescription(e.target.value);
    const handleWarrantyDetailsChange = (e) => setWarrantyDetails(e.target.value);

    const addProduct = async () => {
        const data = {
            name,
            description,
            size,
            color,
            material,
            quantity,
            sellingPrice,
            purchasePrice,
            currency,
            isTaxable,
            taxRate,
            sellerDescription,
            warrantyDetails,
        };

        try {
            const formData = new FormData();
            formData.append('data', new Blob([JSON.stringify(data)], { type: 'application/json' }));
            formData.append('file', image);

            const apiUrl = process.env.REACT_APP_API_URL;
            console.log('API URL:', apiUrl);

            const response = await axios.post(apiUrl+`/api/v1/inventory-service/branch/${branchId}/add/product`, formData, {
                params: { category: selectedCategoryId },
                headers: { 'Content-Type': 'multipart/form-data','Authorization': `Bearer ${token}` }
            });

            if (response === undefined) {
                console.log("Products Added failed");
              } else {
                console.log("products added");
                navigate("/store/branch/list/all/products/"+branchId); 
              }        

            console.log('Item saved successfully:', response.data);
        } catch (error) {
            console.error('Error saving item:', error);
        }
    };

    return (
        <div className="outlet-container">
            <div className="background-white">
                <div className="background-white-sub-container">
                    <br />
                    <ProfileIntiationLablesContainer
                        title="Add Products"
                        description="Add Products details"
                        status={true}
                        icon={productIcon}
                        iconBackgroundColor="#CE7B69"
                    />
                    <AddProductForm branchId={branchId} onSubmit={addProduct}/>

                    <div className="centralised-text">
                        <Button variant="contained" color="primary" onClick={addProduct} label="Add Product"/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddProductsPage;
